import React from 'react';
import SEO from '../components/SEO';
import Header from '../components/landing/Header';
import HeroSection from '../components/landing/HeroSection';
import ComplianceStrip from '../components/landing/ComplianceStrip';
import ServicesSection from '../components/landing/ServicesSection';
import WhyChooseUs from '../components/landing/WhyChooseUs';
import RecruitmentSection from '../components/landing/RecruitmentSection';
import FloridaCoverage from '../components/landing/FloridaCoverage';
import TestimonialsSection from '../components/landing/TestimonialsSection';
import ContactSection from '../components/landing/ContactSection';
import Footer from '../components/landing/Footer';

const LandingPage = () => {
  return (
    <>
      <SEO 
        title="Professional Armed Security Services in Florida"
        description="Armed Guard Officer.com provides licensed, insured armed security services across Florida. Commercial, residential, event, and executive protection services available 24/7."
        keywords="armed security guards Florida, Miami armed security, commercial security services, residential security, event security, executive protection, licensed security guards"
      />
      <div className="min-h-screen bg-[#000000] text-white overflow-x-hidden">
      <Header />
      <main>
        <HeroSection />
        <ComplianceStrip />
        <ServicesSection />
        <WhyChooseUs />
        <RecruitmentSection />
        <FloridaCoverage />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
    </>
  );
};

export default LandingPage;
